var path = '/app/components/data-entry/data-entry-frame.component.html';
var html = "<div class=\"-formcontainer\"> <ui-view></ui-view> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;